import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const syncConversationsFromSyncTime = async (selectedDomain: string, syncTimeStr: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `conversation-messages-sync?domain=${selectedDomain}&st=${encodeURIComponent(syncTimeStr)}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}